import { checkIsObject } from '@/common/data-parsers'

export const SYSTEMS = {
  WINDOWS: 'Windows',
  MACOS: 'macOS',
  LINUX: 'Linux',
  UNKNOWN: 'Unknown',
}

export const BROWSERS = {
  OPERA: 'Opera',
  FIREFOX: 'Firefox',
  SAFARI: 'Safari',
  CHROME: 'Chrome',
  EDGE: 'Edge',
  UNKNOWN: 'Unknown',
}

export default {
  getBrowser() {
    // Chrome 1+
    const isChromiumWindow = 'chrome' in window && checkIsObject(window.chrome) && window.chrome.webstore
    if (isChromiumWindow || window.navigator.userAgent.includes('Chrome')) {
      return BROWSERS.CHROME
    }

    // Firefox 1.0+
    if ('InstallTrigger' in window && window.InstallTrigger !== undefined) {
      return BROWSERS.FIREFOX
    }

    // Edge 20+
    if ('StyleMedia' in window && window.StyleMedia) {
      return BROWSERS.EDGE
    }

    const safariPushNotification: object =
      'safari' in window && checkIsObject(window.safari) && checkIsObject(window.safari.pushNotification)
        ? window.safari.pushNotification
        : {}

    // Safari 3.0+ "[object HTMLElementConstructor]"
    if (
      // this is a hack to detect Safari, maybe .toString() could be used,
      // I migrated the file to TS and did not want to change this, as it was working like this before
      /constructor/i.test(window.HTMLElement as unknown as string) ||
      (function (p: object) {
        return p.toString() === '[object SafariRemoteNotification]'
      })(safariPushNotification)
    ) {
      return BROWSERS.SAFARI
    }

    const isOprWindow = 'opr' in window && checkIsObject(window.opr) && window.opr.addons
    const isOperaWindow = 'opera' in window && window.opera

    // Opera 8.0+
    if (isOprWindow || isOperaWindow || window.navigator.userAgent.includes(' OPR/')) {
      return BROWSERS.OPERA
    }

    return BROWSERS.UNKNOWN
  },

  getSystem() {
    const platform = window.navigator.platform

    if (platform.includes('Mac')) {
      return SYSTEMS.MACOS
    } else if (platform.includes('Win')) {
      return SYSTEMS.WINDOWS
    } else if (platform.includes('Linux')) {
      return SYSTEMS.LINUX
    } else {
      return SYSTEMS.UNKNOWN
    }
  },
}
